import React, { useState, useEffect, useRef } from "react";
import { compose } from "redux";
import Select from 'react-select';

import enhancer from "./validator";

const UserForm = props => {
    
    const selectRole = useRef('');
    const selectCompany = useRef('');

    const [loading, setLoading] = useState(false);
    const [loadingCompany, setLoadingCompany] = useState(false);


    const {
        handleChange,
        handleBlur,
        errors,
        touched,
        submitCount,
        onSubmit,
        setFieldValue,
        values,
        action
    } = props;
    

    const Error = props => {
        const field1 = props.field;
        if ((errors[field1] && touched[field1]) || submitCount > 0) {
            return (
                <span className={props.class ? props.class : "error-msg"}>
                    {errors[field1]}
                </span>
            );
        } else {
            return <span></span>;
        }
    };

    const handleSubmit = () => {
        let { values, isValid, handleSubmit } = props;
        if (isValid) {
            onSubmit(values, action);
        }
        handleSubmit();
    };
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        fetch('/service/companies')
        .then(res => res.json())
        .then(_data => setCompanies(_data))
    }, []);

    useEffect(() => {
        if(values.role && !loading){
            if( values.role === "Normal Kullanıcı"){
                selectRole.current.select.setValue({value: 22, label: "Normal Kullanıcı"})
            }/* else if (values.role === "Servis Üyesi") {
                selectRole.current.select.setValue({value: 15, label: "Servis Üyesi"})
            }*/
            setLoading(true);
        }
    },[values.role])

    useEffect(() => {
        if(values.companies.length && !loadingCompany){
            selectCompany.current.select.setValue(values.companies)
            setLoadingCompany(true);
        }
    },[values.companies])


    
   
    return (
        <div>
            <form>
                <div className="form-group">
                    <label className="fs-16 medium-text">First Name</label>
                    <input
                        type="text"
                        className="form-control react-form-input"
                        id="firstname"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.firstname}
                        placeholder="First Name"
                    />
                    <Error field="firstname" />
                </div>

                <div className="form-group">
                    <label className="fs-16 medium-text">Last Name</label>
                    <input
                        type="text"
                        className="form-control react-form-input"
                        id="lastname"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.lastname}
                        placeholder="Last Name"
                    />
                    <Error field="lastname" />
                </div>

                <div className="form-group">
                    <label className="fs-16 medium-text">Email</label>
                    <input
                        type="email"
                        className="form-control react-form-input"
                        id="email"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email}
                        placeholder="Email"
                    />
                    <Error field="email" />
                </div>

                <div className="form-group">
                    <label className="fs-16 medium-text">Phone Number</label>
                    <input
                        type="text"
                        className="form-control react-form-input"
                        id="phone_number"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.phone_number}
                        placeholder="Phone Number"
                    />
                    <Error field="phone_number" />
                </div>

                
                {   
                    action === 'add' &&
                    <div className="form-group">
                        <label className="fs-16 medium-text">Şifre</label>
                        <input
                            type="password"
                            className="form-control react-form-input"
                            id="password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                            placeholder="Şifre"
                        />
                        <Error field="password" />
                    </div>
                }

                {   
                    action === 'edit' &&
                    <div className="form-group">
                        <label className="fs-16 medium-text">Şifre</label>
                        <input
                            type="password"
                            className="form-control react-form-input"
                            id="password"
                            onBlur={handleBlur}
                            value="protected"
                            placeholder="Şifre"
                            readOnly
                        />
                        <Error field="password" />
                    </div>
                }

                <div className="form-group">
                    <label className="fs-16 medium-text">Şirket</label>
                    <Select
                        className="basic-multi-select"
                        classNamePrefix="select"
                        id='companies'
                        name='companies'
                        ref={selectCompany}
                        onChange={value => setFieldValue('companies', value)}
                        isMulti
                        placeholder="select options"
                        options=
                        {
                            companies.length &&
                            companies.map(company => {
                                return { value: company._id, label: company.name, color: "#00B8D9" }
                            })
                        }

                    />
                    <Error field="companies" />
                </div>

                <div className="form-group">
                    <label className="fs-16 medium-text">Pozisyon</label>

                    <Select
                        placeholder="select options"
                        onChange={value => setFieldValue('role', value)}
                        ref={selectRole}
                        id="role"
                        name="role"
                        options={[
                            { value: 22, label: "Normal Kullanıcı" }
                          ]}
                    />
                    <Error field="role" />
                </div>
                <div>
                    <button
                        type="button"
                        className="c-btn c-info form-button fs-16 demi-bold-text"
                        style={{ maxWidth: "125px" }}
                        onClick={() => handleSubmit()}
                    >
                        Submit
                    </button>
                </div>
            </form>
        </div>
        );
};

export default compose(enhancer)(UserForm);
